import { BaseApiRouteService } from "mrb/core";

class ImpersonationApiRouteService extends BaseApiRouteService {
    constructor() {
        super("impersonation");
    }

    start(userId) {
        return super.create(`${this.base}/{userId}`, { userId });
    }
}

export default ImpersonationApiRouteService;
